<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'Chronotacograph',
  }
</script>

<style scoped>
</style>